// import Cookies from 'js-cookie'

const TokenKey = 'Trade-Admin-Token'
export function getToken() {
  // return Cookies.get(TokenKey)
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  return localStorage.removeItem(TokenKey)
}

const UserNameKey = 'Trade-Admin-User-Name'
export function getUserName() {
  // return Cookies.get(UserNameKey)
  return localStorage.getItem(UserNameKey)
}

export function setUserName(username) {
  // return Cookies.set(UserNameKey, username)
  return localStorage.setItem(UserNameKey, username)
}

export function removeUserName() {
  // return Cookies.remove(UserNameKey)
  return localStorage.removeItem(UserNameKey)
}